import { render, staticRenderFns } from "./AcademyPage.vue?vue&type=template&id=3200e0d0&scoped=true"
import script from "./AcademyPage.vue?vue&type=script&lang=ts"
export * from "./AcademyPage.vue?vue&type=script&lang=ts"
import style0 from "./AcademyPage.vue?vue&type=style&index=0&id=3200e0d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3200e0d0",
  null
  
)

export default component.exports